import React, { useState } from "react";
import { v4 as uuid } from "uuid";
const FormMarket = ({ dispatch }) => {
  const [data, setData] = useState({
    producto: "",
    cant_peso: "",
    done: false,
  });
  const { producto, cant_peso, done } = data;
  const [error, setError] = useState({ error: false, message: "" });
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const actionAdd = {
    type: "add",
    payload: {
      id: uuid(),
      producto,
      cant_peso,
      done,
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleAdd = () => {
    if (producto.trim() === "" && cant_peso.trim() === "") {
      return setError({
        error: true,
        message: "Los campos no pueden estar vacios",
      });
    }
    if (producto.trim() === "") {
      return setError({
        error: true,
        message: "El campo producto no puede estar vacío",
      });
    }
    if (cant_peso.trim() === "") {
      return setError({
        error: true,
        message: "El campo cantidad o peso no puede estar vacío",
      });
    }

    dispatch(actionAdd);
    setData({ producto: "", cant_peso: "" });
  };

  return (
    <div className="container">
      {error.error && setTimeout(() => setError({ error: false }), 4000) && (
        <div className="error">
          <p>{error.message}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="form__container">
        <div className="form__item">
          <label className="form__label">Producto:</label>
          <input
            className="form__input"
            value={producto}
            onChange={handleChange}
            name="producto"
            type="text"
            placeholder="Producto"
            autoComplete="off"
          />
        </div>
        <div className="form__item">
          <label className="form__label ">Cantidad / Peso:</label>
          <input
            className="form__input"
            onChange={handleChange}
            value={cant_peso}
            name="cant_peso"
            type="text"
            placeholder="Cantidad / Peso"
            autoComplete="off"
          />
        </div>

        <button onClick={handleAdd} className="form__btn">
          <i className="fa fa-plus fa-4x" aria-hidden="true"></i>
        </button>
      </form>
    </div>
  );
};

export default FormMarket;
